if (!customElements.get('account-drawer')) {
  class Account extends HTMLElement {
    constructor() {
      super();
      this.accountUrl = this.dataset.accountUrl;
      this.isOpen = false;
      this.registrationForm = this.querySelector('#create_customer');

    }

    connectedCallback() {
      this.addDelegatedClickListeners();
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.get('account_drawer')) this.open();
      if (searchParams.get('reset')) {
        this.querySelector('[data-reset-message]').classList.remove('hidden')
      };
    }

    addDelegatedClickListeners() {
      window.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-account-action]');
        if (window.location.href.indexOf("account") == -1) {
          if (this.isOpen && !e.target.closest('account-drawer')) {
            this.close();
            return;
          } else if (e.target.closest(`[href="${this.accountUrl}"]`)) {
            e.preventDefault();
            this.open();
            return;
          }
        }
        if (!clickedElement) return;
        
        const { 
          accountAction: action,
          accountTarget
        } = clickedElement.dataset;

        switch (action) {
          case 'toggle-section':  
          this.querySelector('[data-reset-password-drawer]')?.classList.add('translate-x-full');
            [...this.querySelectorAll('[data-account-action]')].forEach(btn => {
              btn.dataset.accountTarget === accountTarget ? btn.setAttribute('disabled', true) : btn.removeAttribute('disabled', true); 
            });
            [...this.querySelectorAll('[data-account-section]')].forEach(section => {
              section.dataset.accountSection === accountTarget ? section.classList.remove('hidden') : section.classList.add('hidden'); 
            });
            trapFocusInDialog(this);  
          break;
          case 'close':  
              this.close();  
              this.querySelector('[data-reset-password-drawer]')?.classList.replace('fixed', 'hidden');
              setTimeout(() => {
                this.querySelector('[data-reset-password-drawer]')?.classList.add('translate-x-full');
              }, 500)
          break;
          case 'open-reset-password-drawer':
            this.querySelector('[data-reset-password-drawer]')?.classList.replace('hidden', 'fixed');
            setTimeout(() => {
              trapFocusInDialog(document.querySelector('[data-reset-password-drawer]'));  
              this.querySelector('[data-reset-password-drawer]')?.classList.remove('translate-x-full');
              this.querySelector('[data-account-action="close-reset-password-drawer"]')?.focus();
            }, 10);
          break;
          case 'close-reset-password-drawer': 
            this.querySelector('[data-reset-password-drawer]')?.classList.add('translate-x-full');
            setTimeout(() => {
              this.querySelector('[data-reset-password-drawer]')?.classList.replace('fixed', 'hidden');
              this.querySelector('[data-account-action="open-reset-password-drawer"]')?.focus();
              trapFocusInDialog(this);
            }, 500)
          break;
          default: break;
        }
      })
    }

    open() {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set('account_drawer', 'open');
      history.pushState({}, null, `${window.location.pathname}?${searchParams.toString()}`);

      trapFocusInDialog(this);
      this.classList.replace('hidden', 'fixed');
      this.isOpen = true;
      setTimeout(() => { this.classList.remove('translate-x-full') }, 10);
      this.querySelector('[data-account-action="close"]')?.focus();
      document.body.classList.add('overlay');
      
    }

    close() {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.delete('account_drawer');
      history.pushState({}, null, `${window.location.pathname}?${searchParams.toString()}`);

      this.isOpen = false;
      this.classList.add('translate-x-full');
      document.body.classList.remove('overlay');
      document.querySelector(`[href="${this.accountUrl}"]`)?.focus();
      setTimeout(() => { this.classList.replace('fixed', 'hidden') }, 500);
    }
  }

  customElements.define('account-drawer', Account);
}